import { messaging } from "./firebaseConfig";
import { onMessage } from "firebase/messaging";

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            console.log("Message received. ", payload);
            resolve(payload);
        });
    });
